<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.订单编号')" prop="id">
                <a-input v-model="queryParam.id" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('会员订阅订单.订单编号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.订单状态')" prop="orderStatusList">
                <a-select
                  mode="multiple"
                  :placeholder="$t('通用.输入.请选择')+$t('会员订阅订单.订单状态')"
                  @change="orderStatusListChange"
                  style="width: 100%"
                  v-model="queryParam.orderStatusList"
                  allowClear>
                  <a-select-option
                    v-for="(item, index) in this.customDict.OrderStatusEnum"
                    :value="item.type"
                    :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.订单来源')" prop="source">
                <a-select
                  :placeholder="$t('通用.输入.请选择')+$t('会员订阅订单.订单来源')"
                  style="width: 100%"
                  v-model="queryParam.source"
                  allowClear>
                  <a-select-option
                    v-for="(item, index) in this.customDict.SourceEnum"
                    :value="item.type"
                    :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.用户昵称')" prop="buyerName">
                <a-input v-model="queryParam.buyerName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('会员订阅订单.用户昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订阅档位" prop="subscribeId">
                <a-select
                  :placeholder="$t('通用.输入.请选择')+$t('会员礼品卡.订阅档位')"
                  style="width: 100%"
                  v-model="queryParam.subscribeId"
                  allowClear>
                  <a-select-option
                    v-for="(item, index) in this.subscribeLevelList"
                    :value="item.id"
                    :key="index">
                    {{ item.levelName +' / '+ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.订阅名称')" prop="subscribeName">
                <a-input v-model="queryParam.subscribeName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('会员订阅订单.订阅名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.三方订单号')" prop="outTradeNo">
                <a-input v-model="queryParam.outTradeNo" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('会员订阅订单.三方订单号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.下单开始时间')" prop="createBeginTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.createBeginTime"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('会员订阅订单.下单结束时间')" prop="createEndTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.createEndTime"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-tabs v-model="activeKey" @tabClick="changeTab">
        <a-tab-pane key="" tab="全部订单"/>
        <a-tab-pane v-for="pane in this.customDict.OrderStatusEnum" :key="pane.type" :tab="pane.name">
        </a-tab-pane>
      </a-tabs>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['member:subscribeorder:export']">
          <a-icon type="download" />{{ $t('通用.按钮.导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <detail-form
        ref="detailForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :scroll="{ x: '130%' }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="source" slot-scope="text, record">
          <custom-dict-tag :options="customDict.SourceEnum" :value="record.source"/>
        </span>
        <span slot="orderStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.OrderStatusEnum" :value="record.orderStatus"/>
        </span>
        <span slot="payType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.OrderPayTypeEnum" :value="record.payType"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.detailForm.handleDetail(record.id)">
            <a-icon type="eye" />{{ $t('通用.按钮.详情') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSubscribeOrder, delSubscribeOrder } from '@/api/user/subscribeOrder'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { tableMixin } from '@/store/table-mixin'
import { listSubscribeLevel } from '@/api/user/subscribeLevel'
import DetailForm from './modules/DetailForm'

export default {
  name: 'SubscribeOrder',
  components: {
    CustomDictTag,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      activeKey: null,
      subscribeLevelList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        source: undefined,
        type: undefined,
        buyerId: undefined,
        buyerName: undefined,
        addressDetail: undefined,
        subscribeId: undefined,
        subscribeName: undefined,
        subscribeDetail: undefined,
        payType: undefined,
        payTime: undefined,
        outTradeNo: undefined,
        outTradeAmount: undefined,
        orderStatus: undefined,
        orderStatusList: [],
        refundStatus: undefined,
        orderAmount: undefined,
        payAmount: undefined,
        discountAmount: undefined,
        discountAmountDetail: undefined,
        balanceAmount: undefined,
        isFirstOrder: undefined,
        isUpgrade: undefined,
        isDisplay: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('会员订阅订单.订单编号'),
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          width: '155px',
          fixed: 'left'
        },
        {
          title: this.$t('会员订阅订单.订单状态'),
          dataIndex: 'orderStatusName',
          width: '75px',
          fixed: 'left',
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.订阅名称'),
          dataIndex: 'subscribeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.订单来源'),
          dataIndex: 'source',
          scopedSlots: { customRender: 'source' },
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.用户昵称'),
          dataIndex: 'buyerName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.订单原价'),
          dataIndex: 'orderAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.实付金额'),
          dataIndex: 'payAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.下单时间'),
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.支付方式'),
          dataIndex: 'payType',
          scopedSlots: { customRender: 'payType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.支付时间'),
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('会员订阅订单.三方订单号'),
          dataIndex: 'outTradeNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getSubscribeLevelList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    orderStatusListChange() {
      this.queryParam.orderStatus = undefined
    },
    // 切换tab
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.queryParam.orderStatus = index
      this.getList()
    },
    /** 查询会员订阅订单列表 */
    getList () {
      this.loading = true
     pageSubscribeOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    getSubscribeLevelList () {
      const levelQuery = {
        sortField: 'levelId'
      }
      listSubscribeLevel(levelQuery).then(response => {
        this.subscribeLevelList = response.data
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        source: undefined,
        type: undefined,
        buyerId: undefined,
        buyerName: undefined,
        addressDetail: undefined,
        subscribeId: undefined,
        subscribeName: undefined,
        subscribeDetail: undefined,
        payType: undefined,
        payTime: undefined,
        outTradeNo: undefined,
        outTradeAmount: undefined,
        orderStatus: undefined,
        orderStatusList: [],
        refundStatus: undefined,
        orderAmount: undefined,
        payAmount: undefined,
        discountAmount: undefined,
        discountAmountDetail: undefined,
        balanceAmount: undefined,
        isFirstOrder: undefined,
        isUpgrade: undefined,
        isDisplay: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delSubscribeOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('member/subscribe/order/export',
            that.queryParam
          , `会员订阅订单_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
